import { Grid, Typography } from "@material-ui/core";
import * as React from "react";
import { useDataProvider } from "react-admin";
import { Bar, BarChart, CartesianGrid, LabelList, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import useAiInsight from "../../../Components/AiAssistant/useAiInsight";
import { buildAiBaseParams } from "../../../Components/AiAssistant/buildAiBaseParams";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const CockpitActiveAircraftByPeriod = ({ filterParams }) => {
  const dataProvider = useDataProvider();
  const [data, setData] = React.useState([] as any);

  const insightParams = React.useMemo(() => {
    if (!data.length) return null;
    const counts = data.map((d: any) => d.aircraftCount ?? 0);
    const maxCount = Math.max(...counts);
    const avgCount = (counts.reduce((s: number, c: number) => s + c, 0) / counts.length).toFixed(1);
    const periodTrend = data.map((d: any) => `${d.period}:${d.aircraftCount ?? 0}`).join(",");
    return {
      ...buildAiBaseParams(filterParams),
      periodCount: data.length.toString(),
      maxAircraftCount: maxCount.toString(),
      avgAircraftCount: avgCount,
      periodTrend,
    };
  }, [filterParams, data]);
  useAiInsight("cockpitactiveaircraftbyperiod", insightParams);

  React.useEffect(() => {
    GetActiveAircraftByPeriodData();
  }, [filterParams]);

  const GetActiveAircraftByPeriodData = async () => {
    await dataProvider
      .getList("/pbhrequestorders/cockpit/activeaircraftbyperiod", {
        pagination: { page: 1, perPage: 999999 },
        sort: { field: "id", order: "ASC" },
        filter: filterParams,
      })
      .then(({ data }) => {
        setData(data);
      })
      .catch(error => {
        console.log(error);
      });
  };

  return (
    <>
      <Typography gutterBottom variant="h5" component="h2" align="center">
        Customer Aircrafts
      </Typography>
      <Grid {...gridContainerProps} alignItems={"flex-start"}>
        <Grid item xs={12} sm={5}>
          <div style={{ width: 1000, height: 400 }}>
            <ResponsiveContainer>
              <BarChart
                width={500}
                height={300}
                data={data}
                margin={{
                  top: 50,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="period" />
                <YAxis />
                <Tooltip />
                <Legend
                  payload={[{ value: "Active Aircraft Count", type: "line", id: "aircraftCount", color: "#1f77b4" }]}
                />
                <Bar dataKey="aircraftCount" fill="#1f77b4" minPointSize={5}>
                  <LabelList
                    dataKey="aircraftCount"
                    position="top"
                    style={{ fill: "#333", fontWeight: "bold", fontSize: "14px" }}
                  />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default CockpitActiveAircraftByPeriod;
